/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesLeaderboardsApplicationGetLeaderboardBaseLeaderboardBaseRowResponse { 
    playerId?: number;
    country?: string;
    countryCode?: string;
    shortName?: string;
    sortIndex?: number;
    statusCode?: string;
    pos?: string;
    posStart?: string;
    activeRound?: number;
    groupNumber?: number;
    slotNumber?: number;
    startTee?: number;
    startTime?: string;
    startToPar?: string;
    roundToPar?: string;
    totalToPar?: string;
    roundTotal?: string;
    thru?: string;
    ptsRankStart?: string;
    ptsRankProj?: string;
    ptsRankChange?: string;
    ptsStart?: number;
    ptsProj?: number;
    ptsChange?: string;
}